import React from "react";
import { useHistory, useParams } from "react-router-dom";

import { KintoneExportReport } from "@graffer-inc/cloud-gov-core";

import { KintoneExportSettingDetailContent } from "../../../../../organisms/kintone-export/kintone-export-setting-detail-content";
import { ServiceProviderTemplate } from "../../../../../template/service-provider/default-template";
import {
  useKintoneExportSettingDetailPage,
  useKintoneFieldsByExportSetting,
} from "../../../../data-transfer/kintone-export/page-hooks/kintone-export-setting-detail/hook";
import { ServiceProviderR } from "../../../routes";
import { KintoneExportOrgProductAssertion } from "../plugin/kintone-export-org-product-assertion-plugin";

export const KintoneExportSettingDetailPage: React.FC = () => {
  const { tenantId, kintoneExportSettingId } = useParams<{
    tenantId: string;
    kintoneExportSettingId: string;
  }>();

  const {
    pageContent,
    updateKintoneExportSetting,
    manualExportSubmission,
    deleteKintoneExportedRecord,
    currentExportedRecordsPage,
    setCurrentExportedRecordsPage,
    lastExportedRecordsPage,
    currentExportReportsPage,
    setCurrentExportReportsPage,
    lastExportReportsPage,
  } = useKintoneExportSettingDetailPage({
    tenantId,
    kintoneExportSettingId,
  });

  // 設定の補助のために kintone のフィールドを取得する。
  // kintone の API トークンが無効であった場合でも画面を描画できるように、
  // グラファーの設定データとはあえてクエリを分離している。
  const kintoneFormFieldsInfo = useKintoneFieldsByExportSetting({
    kintoneExportSetting: pageContent?.kintoneExportSetting,
  });

  const history = useHistory();
  const moveToReportDetail = React.useCallback(
    (reportId: KintoneExportReport["id"]) => {
      history.push(
        ServiceProviderR.KintoneExportReportDetail.link({
          tenantId,
          kintoneExportSettingId,
          reportId,
        }),
      );
    },
    [history],
  );

  return (
    <>
      <KintoneExportOrgProductAssertion />
      <ServiceProviderTemplate
        breadcrumbs={[
          {
            to: ServiceProviderR.Home.link({}),
            title: "Home",
          },
          {
            to: ServiceProviderR.DataTransferTop.link({ tenantId }),
            title: "データ連携",
          },
          {
            to: ServiceProviderR.KintoneExportSettings.link({ tenantId }),
            title: "スマート申請の申請データを kintone へ転送",
          },
          {
            to: ServiceProviderR.KintoneExportSettingDetail.link({
              tenantId,
              kintoneExportSettingId,
            }),
            title:
              pageContent?.kintoneExportSetting.name ?? kintoneExportSettingId,
          },
        ]}
      >
        {!!pageContent && (
          <KintoneExportSettingDetailContent
            kintoneExportReports={pageContent.kintoneExportReports}
            kintoneExportSetting={pageContent.kintoneExportSetting}
            kintoneExportedRecords={pageContent.kintoneExportedRecords}
            procedure={pageContent.procedure}
            kintoneFormFieldsInfo={kintoneFormFieldsInfo}
            procedureDetailLink={`${ServiceProviderR.ProcedureDetail.link({
              orgId: tenantId,
              procedureId: pageContent.procedure.id,
            })}?tab=FORM`}
            onClickUpdate={updateKintoneExportSetting}
            onClickExport={manualExportSubmission}
            onClickDeleteKintoneExportedRecord={deleteKintoneExportedRecord}
            moveToReportDetail={moveToReportDetail}
            currentExportedRecordsPage={currentExportedRecordsPage}
            setCurrentExportedRecordsPage={setCurrentExportedRecordsPage}
            lastExportedRecordsPage={lastExportedRecordsPage}
            currentExportReportsPage={currentExportReportsPage}
            setCurrentExportReportsPage={setCurrentExportReportsPage}
            lastExportReportsPage={lastExportReportsPage}
            showJsonEditor
            showKintoneFieldsList
          />
        )}
      </ServiceProviderTemplate>
    </>
  );
};
